module.exports = __webpack_public_path__ + "static/media/icon-header-client-area.809c1610.svg";